/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/9/1
 * @updateTime 2021/9/1
 * @decription 担保 =》 添加担保被申请人表单组件入口js
 */
// 表单布局
import acLayoutForm from '@/components/app/layout/form/index.vue';
import {columnsSFZ, columnsMZ, columnsGZDW, columnsRYLX, columnsSSDW} from '@/utils/option.js';
import validate from '@/utils/validator/validator';
import {
    typeMz,
    typeSfzjlx,
    typeGzdwlx,
    typeZzlx
} from '@/filters/index';
import {
    PhoneRule,
    ZjhmRule,
    XmRule,
    xbRule,
    zjlxRule,
    TxdzRule,
    QymcRule,
    QyfrRule,
    GddhRule,
    nZzlxRule, CQyzzjgdmRule
} from '@/utils/validator/rules';
import {dateFormat} from '@/utils/dateFormatter';
import {checkIdentify, getIDData, createId} from '@/utils/common';
import {mapGetters} from 'vuex';

export default {
    name: 'app-guarantee-add-bsqr',
    data() {
        return {
            // 被申请人id
            bsqrId:'',
            // 诉讼类型为1的表单数据
            formData_1: {},
            // 诉讼类型为2的表单数据
            formData_2: {},
            // 诉讼类型为3的表单数据
            formData_3: {},
            // 表单数据
            formData: {
                // 申请人id
                cId: '',
                // 申请人姓名
                cDsrxm: '',
                // 性别
                cSqrxb: '1',
                // 民族
                nMz: '1',
                // 民族文字描述
                nMzText: '汉族',
                //诉讼地位
                nSsdw: '2',
                //诉讼地位文字
                nSsdwText: '原申请人',
                // 年龄
                nNl: '',
                // 申请人出生日期,
                dtDsrbirthday: '',
                // 申请人出生日期文字描述
                dtSqrBirthdayText: '',
                // 证件类型
                cZjlx: '1',
                // 证件类型汉字描述
                cZjlxText: '居民身份证',
                // 证照类型，默认社会统一信用代码证
                nZzlx: 4,
                nZzlxText: '社会统一信用代码证',
                // 证件号码
                cZjh: '',
                // 固定电话
                cGh: '',
                // 手机号码
                cPhoneno_no: '',
                // 经常居住地
                cTxdz: '',
                // 单位名称
                cQymc: '',
                // 统一社会信用代码
                cZzjgdm: '',
                // 单位性质
                cDwxz: '',
                // 单位性质文字描述
                cDwxzText: '',
                // 企业法人
                cQyfr: '',
                // 申请人类型
                cDsrlx: '1',
                // 申请人类型文本
                cDsrlxText: '自然人',
                // 申请人证件有效期开始日期
                dtZjyxqKsrq: '',
                // 申请人证件有效期开始日期文字描述
                dtZjyxqKsrqText: '',
                // 申请人证件有效期结束日期
                dtZjyxqJsrq: '',
                // 申请人证件有效期结束日期文字描述
                dtZjyxqJsrqText: '',
                // 是否长期有效
                longTerm: false
            },
            // 被申请人类型
            cDsrlx: '1',
            // 被申请人类型描述
            cDsrlxText: '自然人',
            // 申请人类型
            showBsqrlx: false,
            columnsSFZ: columnsSFZ,
            columnsMZ: columnsMZ,
            columnsGZDW: columnsGZDW,
            columnsRYLX: columnsRYLX,
            columnsSSDW:columnsSSDW,
            showZJLXPicker: false,
            showDatePicker: false,
            currentDate: new Date(),
            showMZPicker: false,
            showGZDWPicker: false,
            minDate: new Date("1800-01-01"),
            maxDate: new Date(),
            // 保存按钮是否可以点击
            saveBtnClickable: true,
            // 是否显示证照类型弹层
            showZZPicker: false
        }
    },
    props: {
        // 表单数据
        data: Object
    },
    computed: {
        // 证件类型
        ...mapGetters(['codeList_109000'])
    },
    components: {
        acLayoutForm
    },
    methods: {

        /**
         * 初始化代码值
         * @returns {void}
         * */
        initCodeType() {
            // 证件类型
            this.$store.dispatch('GetCodeType', 109000);
        },

        /**
         * 重置数据
         * @returns {void}
         * */
        resetData() {
            // 申请人id
            this.bsqrId = '';
            // 诉讼类型为1的表单数据
            this.formData_1 = {};
            // 诉讼类型为2的表单数据
            this.formData_2 = {};
            // 诉讼类型为3的表单数据
            this.formData_3 = {};
            // 表单数据
            this.formData = {
                // 申请人id
                cId: '',
                // 申请人姓名
                cDsrxm: '',
                // 性别
                cDsrxb: '1',
                // 民族
                nMz: '1',
                // 民族文字描述
                nMzText: '汉族',
                // 年龄
                nNl: '',
                // 申请人出生日期,
                dtDsrbirthday: '',
                // 证件类型
                cZjlx: '1',
                // 证件类型汉字描述
                cZjlxText: '居民身份证',
                // 证件号码
                cZjh: '',
                // 固定电话
                cGh: '',
                // 手机号码
                cPhoneno_no: '',
                // 经常居住地
                cTxdz: '',
                // 单位名称
                cQymc: '',
                // 统一社会信用代码
                cZzjgdm: '',
                // 单位性质
                cDwxz: '',
                // 单位性质文字描述
                cDwxzText: '',
                // 企业法人
                cQyfr: '',
                // 申请人类型
                cDsrlx: '1',
                // 申请人类型文本
                cDsrlxText: '自然人'
            };
            // 申请人类型
            this.cDsrlx = 1;
            // 申请人类型描述
            this.cDsrlxText = '自然人';
        },
        /**
         * 选择了申请人类型
         * @param {Object} item 申请人信息项数据
         * @returns {void}
         * */
        onSelectBsqrlx(item) {
            // 隐藏申请类型选择面板
            this.showBsqrlx = false;
            // 如果申请人类型不变，则直接返回
            if (item.keyId == this.cDsrlx) {
                return;
            }
            // 申请人类型赋值
            this.cDsrlx = item.keyId;
            // 申请人类型文本赋值
            this.cDsrlxText = item.text;

            // 下面操作，主要是为了点击确认之后，在列表页面不用再转化赋值
            // 申请人类型
            this[`formData_${this.cDsrlx}`].cDsrlx = item.keyId;
            // 申请人类型文本赋值
            this[`formData_${this.cDsrlx}`].cDsrlxText = item.text;
        },

        /**
         * 选择证件类型
         * @param {Object} item 证件类型信息项数据
         * @returns {void}
         * */
        onZJLXConfirm: function (item) {
            this[`formData_${this.cDsrlx}`].cZjlx = item.keyId;
            this[`formData_${this.cDsrlx}`].cZjlxText = item.text;
            this.showZJLXPicker = false;
        },

        /**
         * 选择出生日期
         * @returns {void}
         * */
        onDatePickerConfirm: function () {
            this.currentDate = new Date(this.currentDate.setHours(8));
            this[`formData_${this.cDsrlx}`].dtDsrbirthday = dateFormat(this.currentDate, "yyyy-MM-dd");
            this.showDatePicker = false;
        },

        /**
         * 解析身份证号
         * @returns {void}
         * */
        identifyAnalyzer: function () {
            // 如果证件类型不为1 身份证号，则直接返回
            if (this[`formData_${this.cDsrlx}`].cZjlx != 1) {
                return;
            }
            // 证件号码
            let zjhm = this[`formData_${this.cDsrlx}`].cZjh;
            // 校验证件号码是否正确
            let correct = checkIdentify(zjhm);
            if (correct) {
                // 身份证号格式正确, 向服务器查询 生日, 性别, 年龄 信息
                getIDData(zjhm).then(res => {
                    let data = res.data;
                    this[`formData_${this.cDsrlx}`] = {
                        ...this[`formData_${this.cDsrlx}`],
                        ...{
                            dtDsrbirthday: data.cBirthdate,
                            nNl: data.nAge,
                            cDsrxb: data.cSex
                        }
                    };
                });
            }
        },

        /**
         * 选择民族
         * @param {Object} item 民族信息项数据
         * @returns {void}
         * */
        onMZConfirm: function (item) {
            this[`formData_${this.cDsrlx}`].nMz = item.keyId;
            this[`formData_${this.cDsrlx}`].nMzText = item.text;
            this.showMZPicker = false;
        },

        /**
         * 选择证照类型
         * @param {Object} item 证照类型信息项数据
         * @returns {void}
         * */
        onZZConfirm: function(item){
            this[`formData_${this.cDsrlx}`].nZzlx = item.keyId;
            this[`formData_${this.cDsrlx}`].nZzlxText = item.text;
            this.showZZPicker = false;
        },

        /**
         * 选择单位性质
         * @param {Object} item 单位性质信息项数据
         * @returns {void}
         * */
        onGZDWConfirm: function (item) {
            this[`formData_${this.cDsrlx}`].cDwxz = item.keyId;
            this[`formData_${this.cDsrlx}`].cDwxzText = item.text;
            this.showGZDWPicker = false;
        },

        /**
         * 获取参数
         * */
        getParams() {
            return this[`formData_${this.cDsrlx}`];
        },

        /**
         * 返回事件
         * @returns {void}
         * */
        back() {
            this.$emit('cancel');
        },

        /**
         * 刷新操作
         * @returns {void}
         * */
        refresh() {
            // 重置数据
            this.resetData();
            // 重新走初始化流程
            this.init();
            // 返回顶部
            this.$refs.con && this.$refs.con.goToTop();
        },

        /**
         * 添加/确认按钮点击事件
         * @returns {void}
         * */
        addBsqrAndReturn: function () {
            // 验证表单数据
            this.validateFormData().then(() => {
                // 向上分发确认事件
                this.$emit('confirm', this[`formData_${this.cDsrlx}`]);
            }).catch(() => {
                console.log('校验不通过！');
            });
        },

        /**
         * 确认并添加按钮点击事件
         * @returns {void}
         * */
        addBsqrAndContinue: function () {
            // 验证表单数据
            this.validateFormData().then(() => {
                // 向上分发确认并继续事件
                this.$emit('confirm-continue', this[`formData_${this.cDsrlx}`]);
                // 刷新当前表单
                this.refresh();
            }).catch(() => {
                console.log('校验不通过！');
            });
        },

        /**
         * 申请类型为1 自然人的表单验证
         * @returns {Promise}
         * */
        validateFormData_1: function() {
            // 自然人校验规则
            const descriptor = {
                // 姓名
                cDsrxm: new XmRule(true),
                // 证件类型
                cZjlx: zjlxRule,
                // 证件号码
                cZjh: new ZjhmRule(this.formData_1.cZjlx, true),
                // 性别
                cDsrxb: xbRule,
                // 手机号码
                cPhoneno_no: new PhoneRule(false),
                // 固定电话
                cGh: new GddhRule(false),
                // 经常居住地
                cTxdz: new TxdzRule(this.cDsrlx, false)
            };
            let validated = validate(descriptor, this.formData_1);
            return validated;
        },

        /**
         * 申请类型为 2 法人的表单验证
         * @returns {Promise}
         * */
        validateFormData_2: function() {
            // 自然人校验规则
            const descriptor = {
                // 单位名称
                cQymc: new QymcRule(true),
                // 证照类型
                nZzlx: nZzlxRule,
                // 证照号码
                cZzjgdm: new CQyzzjgdmRule(Number(this.formData_2.nZzlx),true),
                // 法定代表人
                cQyfr: new QyfrRule(this.cDsrlx, true),
                // 手机号码
                cPhoneno_no: new PhoneRule(false),
                // 固定电话
                cGh: new GddhRule(false),
                // 单位地址
                cTxdz: new TxdzRule(this.cDsrlx, true)
            };
            let validated = validate(descriptor, this.formData_2);
            return validated;
        },

        /**
         * 申请类型为 3 非法人组织的表单验证
         * @returns {Promise}
         * */
        validateFormData_3: function() {
            // 自然人校验规则
            const descriptor = {
                // 单位名称
                cQymc: new QymcRule(true),
                // 证照类型
                nZzlx: nZzlxRule,
                // 证照号码
                cZzjgdm: new CQyzzjgdmRule(Number(this.formData_2.nZzlx),true),
                // 法定代表人
                cQyfr: new QyfrRule(this.cDsrlx, true),
                // 手机号码
                cPhoneno_no: new PhoneRule(false),
                // 固定电话
                cGh: new GddhRule(false),
                // 单位地址
                cTxdz: new TxdzRule(this.cDsrlx, true)
            };
            let validated = validate(descriptor, this.formData_3);
            return validated;
        },

        /**
         * 验证表单数据
         * @returns {Promise}
         * */
        validateFormData: function () {
            return new Promise((resolve, reject) => {
                // 对应的验证规则
                const validated = this[`validateFormData_${this.cDsrlx}`]();
                validated.then(() => {
                   // 校验通过
                   resolve();
                }).catch(() => {
                    console.log('请完整填写表单数据');
                    reject();
                });
            });
        },

        /**
         * 初始化方法
         * @returns {void}
         * */
        init() {
            // 如果数据存在
            if (this.data) {
                // 表单数据赋值默认的表单数据
                this.formData_1 = {
                    ...this.formData
                };
                this.formData_2 = {
                    ...this.formData
                };
                this.formData_3 = {
                    ...this.formData
                };
                // 数据进行赋值
                const _formData = {
                    ...this.data
                };
                // 民族需要转化成文本
                _formData.nMzText = typeMz(_formData.nMz);
                // 证件类型
                _formData.cZjlxText = typeSfzjlx(_formData.cZjlx);
                // 单位性质
                _formData.cDwxzText = typeGzdwlx(_formData.cDwxz);
                // 证照类型
                _formData.nZzlxText = typeZzlx(_formData.nZzlx);
                // 被申请人id赋值
                this.bsqrId = _formData.cId;
                // 申请人类型
                this.cDsrlx = _formData.cDsrlx;
                // 申请人类型文本
                this.cDsrlxText = _formData.cDsrlxText;
                // 表单id赋值
                this.formData_1.cId = _formData.cId;
                // 表单id赋值
                this.formData_2.cId = _formData.cId;
                // 表单id赋值
                this.formData_3.cId = _formData.cId;
                // 表单赋值
                this[`formData_${_formData.cDsrlx}`] = _formData;
            } else {
                // 创建id
                createId().then(id => {
                    this.formData.cId = id;
                    // 设置是属于新增
                    this.formData.isAdd = true;
                    // 表单数据赋值默认的表单数据
                    this.formData_1 = {
                        ...this.formData
                    };
                    this.formData_2 = {
                        ...this.formData
                    };
                    this.formData_3 = {
                        ...this.formData
                    };
                });
            }
        }
    },
    created() {
        // 初始化代码值
        this.initCodeType();
        // 初始化方法
        this.init();
    }
}
